<template>
    <LayoutBase>
        <header id="header">
            <div class="container">
                <div class="">
                    <h1 class="h1">Groups</h1>
                </div>
                <div class="text-right">
                    <router-link :to="{ name: 'new-group' }" class="btn btn-primary">Create a group</router-link>
                </div>
            </div>
        </header>

        <div class="container">
            <div class="groups row">
                <div class="group col-4" v-for="group in groups">
                    <div class="card">
                        <router-link :to="{ name: 'view-group', params: { group: group.slug }}">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <h2 class="h4">{{ group.name }}</h2>
                                    <p class="article-count">{{ group.posts_count }} posts</p>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';
    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                groups: [],
                group: {
                    private: 0
                }
            }
        },
        mounted() {
            this.getGroups();
        },
        methods: {
            getGroups() {
                axios.get('/api/groups').then((response) => {
                    this.groups = response.data;
                    //console.log(this.posts.slice(0, 1));
                }, (response) => {
                    this.error = response;
                });
            },
            createGroup(){
                axios.post('/api/groups', this.group).then((response) => {
                }, (response) => {
                    this.error = response;
                });
            },
        }
    }
</script>

<style lang="scss">
    
</style>